const home = () => import('@/views/summer-camp/sc-home')
const interact = () => import('@/views/summer-camp/interact/interact')
const introduce = () => import('@/views/summer-camp/introduce/introduce')
const scList = () => import('@/views/summer-camp/sc-list')
const scDetail = () => import('@/views/summer-camp/sc-detail')
const scCourse = () => import('@/views/summer-camp/sc-course')

export default [
    {
        path: 'home',
        component: home,
        meta: {
            title: '暑期提分营'
        }
    },
    {
        name: '互动讨论',
        path: 'interact/:ttaId?',
        component: interact,
    },
    {
        path: 'introduce',
        component: introduce,
        meta: {
            title: '酷爽提分营'
        }
    },
    {
        path: 'sc-list',
        component: scList,
        meta: {
            title: '已加入同学'
        }
    },
    {
        path: 'sc-detail',
        component: scDetail,
        meta: {
            title: '全部课程安排'
        }
    },
    {
        path: 'sc-course',
        component: scCourse,
        meta: {
            title: '全部课程安排'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/summer-camp.js